import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=6493d495&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=ts&"
export * from "./TopNav.vue?vue&type=script&lang=ts&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=6493d495&lang=scss&scoped=true&"
import style1 from "./TopNav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493d495",
  null
  
)

/* custom blocks */
import block0 from "./TopNav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports